import { Box, Grid } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const GridContainerShadow = styled(Grid)`
  &.MuiGrid-root {
    box-shadow: 10px 0px 14px rgba(77, 88, 147, 0.1);
    z-index: 1;
  }
`;

export const MapContainer = styled(Box)`
  &.MuiBox-root {
    position: fixed;
    width: 48vw;
    padding: 0;
    top: 0;
    z-index: 101;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 100%;
      background: linear-gradient(to right, rgba(77, 88, 147, 0.1), transparent);
      pointer-events: none;
      z-index: 1;
    }
  }
`;
